import React from "react";

import "./pharmacyDistributionData.css";

const PharmacyDistributioData = ({
  page,
  period,
  pharmacyDistributionData,
}) => {
  return (
    <div className="profit-table-container">
      <h4>Periode {period}</h4>
      <table className="profit-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Obat</th>
            <th>Unit Produk</th>
            <th>Stok Terjual</th>
            <th>Sisa Stok</th>
            <th>Supplier</th>
          </tr>
        </thead>
        <tbody>
          {pharmacyDistributionData.length > 0 ? (
            pharmacyDistributionData.map((data, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{data.product_name}</td>
                <td>{data.product_unit_name ? data.product_unit_name : "-"}</td>
                <td>{data.product_total_sold}</td>
                <td
                  style={{
                    color: data.product_stock_remaining < 0 ? "red" : "black",
                  }}
                >
                  {data.product_stock_remaining}
                </td>
                <td>{data.product_latest_supplier_name}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PharmacyDistributioData;
